import {NatGetMessageList, SearchCondition, SearchConditionPageInfo} from './NatGetMessageList'
import {NatGetMessage} from './NatGetMessage'
import {NatPostMessage, NatPostMessageParams} from './NatPostMessage'
import {NatPutMessage, NatPutMessageParams} from './NatPutMessage'
import {NatDeleteMessage} from './NatDeleteMessage'
import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants';
import {SortOrder} from '../../../../components/shared/SortOrder';

export default class NatMessageRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // メッセージ取得(ログイン済)
    async getMessage(messageId: string): Promise<NatGetMessage> {
        return await this.http.get(`/api/common/message/authed/${messageId}`);
    }

    // 居住者画面用メッセージ取得(ログイン済)
    async getMessageForResident(messageId: string): Promise<NatGetMessage> {
        return await this.http.get(`/api/resident/message/authed/${messageId}`);
    }
    // メッセージ一覧取得(ログイン済)
    async getMessageList(
        searchCondition?: SearchCondition,
        searchConditionPageInfo?: SearchConditionPageInfo,
        searchConditionSortInfos?: SortOrder[],
    ): Promise<NatGetMessageList> {
        const searchParams: string[] = [];
        if (searchCondition) {
            if (searchCondition.condominiumGroupId) {
                searchParams.push(`condominiumGroupId=${encodeURIComponent(searchCondition.condominiumGroupId)}`);
            }
            if (searchCondition.condominiumCd) {
                searchParams.push(`condominiumCd=${encodeURIComponent(searchCondition.condominiumCd)}`);
            }
            if (searchCondition.condominiumName) {
                searchParams.push(`condominiumName=${encodeURIComponent(searchCondition.condominiumName)}`);
            }
            if (searchCondition.deliveryTargetPrefectureCd) {
                searchParams.push(`deliveryTargetPrefectureCd=${encodeURIComponent(searchCondition.deliveryTargetPrefectureCd)}`);
            }
            if (searchCondition.deliveryTargetAddress2) {
                searchParams.push(`deliveryTargetAddress2=${encodeURIComponent(searchCondition.deliveryTargetAddress2)}`);
            }
            if (searchCondition.extractStart) {
                searchParams.push(`extractStart=${encodeURIComponent(searchCondition.extractStart)}`);
            }
            if (searchCondition.extractEnd) {
                searchParams.push(`extractEnd=${encodeURIComponent(searchCondition.extractEnd)}`);
            }
            if (searchCondition.categoryId) {
                searchParams.push(`categoryId=${encodeURIComponent(searchCondition.categoryId)}`);
            }
            if (searchCondition.condominiumMessageFlag) {
                searchParams.push(
                    `condominiumMessageFlag=${encodeURIComponent(searchCondition.condominiumMessageFlag)}`);
            }
            if (searchCondition.doNotify) {
                searchParams.push(
                    `doNotify=${encodeURIComponent(searchCondition.doNotify)}`);
            }
        }

        if (searchConditionPageInfo) {
            if (searchConditionPageInfo.pageNum) {
                searchParams.push(`pageNum=${encodeURIComponent(searchConditionPageInfo.pageNum)}`);
            }
            searchParams.push(`page=${encodeURIComponent(searchConditionPageInfo.page)}`);
        }

        if (searchConditionSortInfos) {

            searchConditionSortInfos.forEach((sortInfo, index) => {
                const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`);
                searchParams.push(`sortInfo=${value}`)
            })
        }

        const searchParamsText: string = searchParams.join('&');
        return await this.http.get(`/api/common/message/authed?${searchParamsText}`);
    }

    // メッセージ登録
    async postMessage(messageRegisterParams: NatPostMessageParams): Promise<NatPostMessage> {
        return await this.http.post(`/api/admin/message`, {
            messageCopyOrgId: messageRegisterParams.messageCopyOrgId,
                condominiumGroupId: messageRegisterParams.condominiumGroupId,
                deliveryTargetPrefectureCd: messageRegisterParams.deliveryTargetPrefectureCd,
                deliveryTargetAddress2: messageRegisterParams.deliveryTargetAddress2,
                messageNotDeliveryCondominium: messageRegisterParams.messageNotDeliveryCondominium,
                categoryId: messageRegisterParams.categoryId,
                title: messageRegisterParams.title,
                description: messageRegisterParams.description,
                publishStartDate: messageRegisterParams.publishStartDate,
                publishEndDate: messageRegisterParams.publishEndDate,
                topFixed: messageRegisterParams.topFixed,
                copyAvailability: messageRegisterParams.copyAvailability,
            messageFile: messageRegisterParams.messageRegisteredFileList,
            doNotify: messageRegisterParams.doNotify
            }, ContentType.JSON,
        );
    }

    // メッセージ更新
    async putMessage(messageEditParams: NatPutMessageParams): Promise<NatPutMessage> {
        return await this.http.put(`/api/admin/message`, messageEditParams);
    }

    // メッセージ削除
    async deleteMessage(messageId: string): Promise<NatDeleteMessage> {
        return await this.http.delete(`/api/admin/message/${messageId}`);
    }

}
